import { render, staticRenderFns } from "./dy.vue?vue&type=template&id=8b3c499c&scoped=true"
import script from "./dy.vue?vue&type=script&lang=js"
export * from "./dy.vue?vue&type=script&lang=js"
import style0 from "./dy.vue?vue&type=style&index=0&id=8b3c499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c499c",
  null
  
)

export default component.exports